import { Grid, Typography, CircularProgress, Box } from '@mui/material'
import React, { useEffect, useState, useRef, useCallback } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { styled } from '@mui/material/styles'
import ArrowIconRight from '../../Assets/Icons/Arrow_Small_Right.svg'
import PDFIcon from '../../Assets/Icons/PDF_Icon.svg'
import XLSXIcon from '../../Assets/Icons/XL_Icon.svg'
import DOCIcon from '../../Assets/Icons/Doc_Icon.svg'
import UnknownFile from '../../Assets/Icons/document_icon.svg'
import NIRFExData from '../../Assets/JSON/NIRF/NIRFExtended_Data.json'
import '../../Styles/Naac.css'
import { useNavigate } from 'react-router-dom'

const NIRFExtended = () => {
  const [expanded, setExpanded] = useState(0)
  const [selectedNIRFData, setSelectedNIRFData] = useState([])
  const [isLoading, setIsLoading] = useState(false) // State for loader
  const isMounted = useRef(true)
  const navigate = useNavigate()
  const NIRFExtended_DATA = NIRFExData?.NIRFExtended_Headings
  const NIRFSubheadingData = NIRFExData.NIRFExtended_Data

  const handleChange = (panel, index) => (event, newExpanded) => {
    localStorage.setItem('expandedIndex', newExpanded ? panel : 1)
    setExpanded(newExpanded ? panel : false)
  }

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  }))

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    color: theme.palette.mode === 'dark' ? '#fff' : 'black',
  }))

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={
        <img
          src={ArrowIconRight}
          loading="lazy"
          placeholder="blur"
           alt="Arrow Icon"
        />
      }
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
      backgroundColor: theme.palette.mode === 'dark' ? '#ffff' : '#eeee',
      borderRadius: '50%',
    },
  }))

  const filterData = useCallback(
    (selected) => {
      setIsLoading(true)
      setTimeout(() => {
        const filter_data = NIRFSubheadingData.filter(
          (NIRFdata) => NIRFdata.ID === selected.ID
        )
        setSelectedNIRFData(filter_data)
        setIsLoading(false)
      }, 1000)
    },
    [NIRFSubheadingData]
  )

  useEffect(() => {
    if (NIRFSubheadingData && NIRFSubheadingData.length > 0) {
      filterData(NIRFSubheadingData[0])
    }

    return () => {
      isMounted.current = false
    }
  }, [NIRFSubheadingData, filterData])

  const handlePdfClick = (urldata) => {
    if (!urldata.pathurl.trim()) {
      toast.error('There is no file', {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }
    navigate('/nirf/' + urldata.id + '/' + urldata.filename, {
      state: { selectedDocData: urldata },
    })
  }

  const getFileIcon = (filename) => {
    const ext = filename.split('.').pop().toLowerCase()
    switch (ext) {
      case 'pdf':
        return PDFIcon
      case 'xlsx':
        return XLSXIcon
      case 'doc':
      case 'docx':
        return DOCIcon
      default:
        return UnknownFile
    }
  }

  return (
    <section className="container">
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            {NIRFExtended_DATA &&
              NIRFExtended_DATA.map((items, parentIndex) => {
                const isExpanded = expanded === parentIndex

                return (
                  <Accordion
                    key={parentIndex}
                    expanded={isExpanded}
                    onChange={handleChange(parentIndex)}
                  >
                    <AccordionSummary
                      style={{
                        backgroundColor: isExpanded
                          ? 'rgb(25, 47, 89)'
                          : '#D0D0D0',
                        color: isExpanded ? 'white' : 'inherit',
                      }}
                      onClick={() => {
                        if (!isExpanded) {
                          const firstSubheading = items.SubHeading[0]
                          filterData(firstSubheading)
                        }
                      }}
                      disabled={items.isActive === false}
                    >
                      <Typography>{items.Heading}</Typography>
                    </AccordionSummary>
                    {items?.SubHeading &&
                      items.SubHeading.map((subdata, i) => {
                        return (
                          <AccordionDetails
                            key={i}
                            onClick={() => filterData(subdata)}
                            sx={{
                              '& .MuiTypography-root': {
                                fontSize: '0.9rem',
                                margin: 'auto',
                                position: 'relative',
                                left: '15px',
                              },
                            }}
                            className={
                              selectedNIRFData.some(
                                (data) => data.ID === subdata.ID
                              )
                                ? 'selected cursor-pointer'
                                : 'AccordionSummary cursor-pointer'
                            }
                          >
                            <Typography>{subdata.Subheading}</Typography>
                          </AccordionDetails>
                        )
                      })}
                  </Accordion>
                )
              })}
          </Grid>
          <Grid item xs={12} md={8}>
            {isLoading ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                }}
              >
                <CircularProgress />
              </Box>
            ) : selectedNIRFData[0]?.URLs ? (
              <Box>
                {selectedNIRFData.map((HeadItem) =>
                  Object.entries(HeadItem.URLs).map(([key, value]) => (
                    <Box
                      key={key}
                      className="container"
                      sx={{ marginBottom: 4 }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          marginBottom: '10px',
                          fontWeight: '600',
                          fontSize: '2rem',
                          color: '#333',
                        }}
                      >
                        {value.map((items) => items.Title)}
                      </Typography>

                      <Grid container spacing={2} justifyContent="start">
                        {value.map((urldata, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                padding: '20px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                cursor: 'pointer',
                                margin: '0 0 0 10px',
                                backgroundColor: '#fff',
                              }}
                              onClick={() => handlePdfClick(urldata)}
                            >
                              <img
                                src={getFileIcon(urldata.filename)}
                                style={{
                                  width: '70px',
                                  height: '70px',
                                  marginBottom: '12px',
                                }}
                                alt="File Icon"
                                loading="lazy"
                                placeholder="blur"
                              />
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 'bold', color: '#333' }}
                              >
                                {urldata.filename}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  ))
                )}
              </Box>
            ) : (
              <Box sx={{ textAlign: 'center', padding: 5 }}>
                <Typography variant="h6">No Data Selected</Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </div>
      <ToastContainer />
    </section>
  )
}

export default NIRFExtended
